/*** IMPORTS FROM imports-loader ***/
var define = false;

// Predicate-generating function. Often useful outside of Underscore.
export default function constant(value) {
  return function() {
    return value;
  };
}




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/constant.js
// module id = 62
// module chunks = 0